module.exports = __webpack_public_path__ + "static/media/Terms & Conditions.cd6d7b77.pdf";